export default __webpack_public_path__ + "static/media/loc_img_6.507ed9a5.jpg";